import React from 'react';
import AdaptiveHelpTip from '@amzn/storm-ui-adaptive-helptip';
import { Switch, Text, Tooltip } from '@amzn/storm-ui';
import { Toggle } from '../types';

export const AttributesToggle: React.VFC<Toggle> = ({
  id,
  isDisabled,
  isActive,
  toolTip,
  tooltipPosition,
  eventHandler,
  ariaLabel,
  isNonInteractiveTooltip,
}) => {
  const switchAttribute = (
    <Switch
      id={id}
      data-eventid={id}
      onChange={(...args) =>
        eventHandler(args.length === 2 ? args[1] : args[0])
      }
      small={true}
      disabled={isDisabled}
      toggled={isActive}
      aria-label={ariaLabel}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      style={isDisabled ? { pointerEvents: 'none' } : {}}
    />
  );

  if (isNonInteractiveTooltip && toolTip?.length) {
    return (
      <>
        {isDisabled ? (
          <Tooltip
            nonInteractive
            trigger={
              <div tabIndex={0} aria-disabled="true" aria-label={ariaLabel}>
                {switchAttribute}
              </div>
            }
            type="dark"
          >
            <Text>{toolTip}</Text>
          </Tooltip>
        ) : (
          switchAttribute
        )}
      </>
    );
  }

  return (
    <>
      {switchAttribute}
      {toolTip?.length && (
        <AdaptiveHelpTip
          tooltipProps={{
            withCloseButton: false,
            position: tooltipPosition,
            type: isDisabled ? 'dark' : 'light',
          }}
        >
          <Text>{toolTip}</Text>
        </AdaptiveHelpTip>
      )}
    </>
  );
};
